import React from 'react';
import { X, CalendarCheck, FirstAidKit, Eye, Check, Trash } from '@phosphor-icons/react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const LeaveTable = ({ items, typeMap, isAdmin, mainTab, onAction, onDelete, badge, statusMap }) => (
  <table className="data-table" data-testid="leaves-table">
    <thead>
      <tr>
        {isAdmin && <th>Salarie</th>}
        <th>Type</th><th>Du</th><th>Au</th><th>Jours</th><th>Motif</th><th>Statut</th>
        {mainTab === 'maladie' && <th>Attestation</th>}
        <th></th>
      </tr>
    </thead>
    <tbody>
      {items.map(l => (
        <tr key={l.id}>
          {isAdmin && <td style={{ fontWeight: '600' }}>{l.user_name}</td>}
          <td>{badge(typeMap, l.type)}</td>
          <td>{l.start_date}</td><td>{l.end_date}</td>
          <td style={{ fontWeight: '700' }}>{l.days}</td>
          <td style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{l.reason || '-'}</td>
          <td>{badge(statusMap, l.status)}</td>
          {mainTab === 'maladie' && (
            <td>
              {l.attestation_filename ? (
                <a href={`${API_URL}/api/leaves/attestation/${l.attestation_filename}`} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm" data-testid={`view-att-${l.id}`}><Eye size={12} /></a>
              ) : <span style={{ color: '#9E9E9E', fontSize: '0.8rem' }}>-</span>}
            </td>
          )}
          <td>
            <div style={{ display: 'flex', gap: '4px' }}>
              {isAdmin && l.status === 'en_attente' && (
                <>
                  <button className="btn btn-primary btn-sm" onClick={() => onAction(l.id, 'approuve')} data-testid={`approve-${l.id}`}><Check size={14} /></button>
                  <button className="btn btn-danger btn-sm" onClick={() => onAction(l.id, 'refuse')} data-testid={`refuse-${l.id}`}><X size={14} /></button>
                </>
              )}
              <button className="btn btn-danger btn-sm" onClick={() => onDelete(l.id)}><Trash size={12} /></button>
            </div>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

export const LeaveRequestModal = ({ show, onClose, onSubmit, form, setForm, isMaladie, attestationFile, setAttestationFile }) => {
  if (!show) return null;
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ backgroundColor: 'white', borderRadius: '4px', width: '100%', maxWidth: '520px' }}>
        <div style={{ padding: '20px 24px', borderBottom: '1px solid #E2E2E6', display: 'flex', justifyContent: 'space-between' }}>
          <h3 style={{ margin: 0 }}>{isMaladie ? 'Declaration arret / absence' : 'Demande de conge'}</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer' }}><X size={24} /></button>
        </div>
        <form onSubmit={onSubmit} style={{ padding: '24px' }}>
          {isMaladie && (
            <div className="form-group">
              <label className="form-label">Type *</label>
              <Select value={form.type} onValueChange={(v) => setForm({ ...form, type: v })}>
                <SelectTrigger data-testid="leave-type-select"><SelectValue /></SelectTrigger>
                <SelectContent className="z-[9999]">
                  <SelectItem value="maladie">Arret maladie</SelectItem>
                  <SelectItem value="absence">Absence</SelectItem>
                </SelectContent>
              </Select>
            </div>
          )}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            <div className="form-group"><label className="form-label">Date debut *</label><input type="date" className="form-input" value={form.start_date} onChange={(e) => setForm({ ...form, start_date: e.target.value })} required /></div>
            <div className="form-group"><label className="form-label">Date fin *</label><input type="date" className="form-input" value={form.end_date} onChange={(e) => setForm({ ...form, end_date: e.target.value })} required /></div>
          </div>
          <div className="form-group">
            <label className="form-label">Motif {isMaladie ? '*' : ''}</label>
            <textarea className="form-input" rows={2} value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })} required={isMaladie} placeholder={isMaladie ? 'Motif obligatoire' : 'Optionnel'} />
          </div>
          {isMaladie && (
            <div className="form-group">
              <label className="form-label">Attestation / Justificatif</label>
              <input type="file" className="form-input" accept="image/*,.pdf" onChange={(e) => setAttestationFile(e.target.files[0])} data-testid="attestation-input" />
              <span style={{ fontSize: '0.75rem', color: '#5E5F66' }}>Image ou PDF depuis votre appareil</span>
            </div>
          )}
          <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
            <button type="button" className="btn btn-secondary" onClick={onClose} style={{ flex: 1 }}>Annuler</button>
            <button type="submit" className="btn btn-primary" style={{ flex: 1 }} data-testid="submit-leave">Envoyer</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export const LeaveConfigModal = ({ show, onClose, onSubmit, config, setConfig }) => {
  if (!show) return null;
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ backgroundColor: 'white', borderRadius: '4px', width: '100%', maxWidth: '400px' }}>
        <div style={{ padding: '20px 24px', borderBottom: '1px solid #E2E2E6', display: 'flex', justifyContent: 'space-between' }}>
          <h3 style={{ margin: 0 }}>Configuration conges</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer' }}><X size={24} /></button>
        </div>
        <form onSubmit={onSubmit} style={{ padding: '24px' }}>
          <div className="form-group"><label className="form-label">Jours de conges annuels</label><input type="number" className="form-input" value={config.annual_days} onChange={(e) => setConfig({ ...config, annual_days: parseInt(e.target.value) || 0 })} data-testid="config-annual-days" /></div>
          <div className="form-group"><label className="form-label">Jours RTT</label><input type="number" className="form-input" value={config.rtt_days} onChange={(e) => setConfig({ ...config, rtt_days: parseInt(e.target.value) || 0 })} /></div>
          <button type="submit" className="btn btn-primary" style={{ width: '100%' }} data-testid="save-config-btn">Sauvegarder</button>
        </form>
      </div>
    </div>
  );
};
